export type PulsarOutcomeItem = {
  success?: boolean | null;
};

export type PulsarOutcomes = {
  total: number;
  success: number;
  failed: number;
  unclassified: number;
  success_rate: number | null;
};

export function countPulsarOutcomes(items: PulsarOutcomeItem[] | null | undefined): PulsarOutcomes {
  let success = 0;
  let failed = 0;
  let unclassified = 0;
  for (const item of items || []) {
    if (item?.success === true) success += 1;
    else if (item?.success === false) failed += 1;
    else unclassified += 1;
  }
  const classified = success + failed;
  return {
    total: success + failed + unclassified,
    success,
    failed,
    unclassified,
    success_rate: classified > 0 ? (100 * success) / classified : null,
  };
}

export function formatPulsarSuccessRate(rate: number | null | undefined): string {
  if (rate == null || !Number.isFinite(rate)) return 'n/a';
  return `${rate.toFixed(1)}%`;
}
